import * as React from "react"

import Home from "../components/update"
import Seo from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"

const KargoPage = () => (
<Home>
<Seo title="Aplikasi Kargo Ekspedisi" />

<div className="container">
<div className="row mt-5">
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">
<h1><strong><a href="/kargo/">Aplikasi Kargo</a></strong></h1>
<h2>Pembukuan kargo ekspedisi pengiriman website dan aplikasi all in one.</h2>
<p>Solusi untuk kebutuhan pencatatan usaha bisnis kargo dan ekspedisi dengan kemudahan untuk input data dalam melakukan transaksi dengan status pembayaran pelanggan seperti cash tunai, dp , bayar di tempat dan lain sebagai nya, status kiriman barang include update seperti barang masih digudang, barang dalam proses kirim , dan barang sampai di tujuan. Dukungan untuk mencatat pengirim barang kiriman, penerima, lengkap dengan jumlah dan berapa banyak koli paket dus dalam transaksi nya, plus kebutuhan pencatatan keuangan detail, cashflow arus keluar masuk, dan cek resi pada website kargo ekspedisi.</p>
<ul className="nav nav-pills mb-3" id="pills-tab">
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Cover</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-demokasir-tab" data-bs-toggle="pill" data-bs-target="#pills-demokasir" type="button" role="tab" aria-controls="pills-demokasir" aria-selected="false">Demo</button>
  </li>
</ul>
</div>
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">

<div className="tab-content" id="pills-tabContent">
  <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
  <StaticImage
src="../img/cargoapp.webp"
className="img-fluid rounded shadow"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="aplikasi kargo ekspedisi"
/>
  </div>
  <div className="tab-pane fade" id="pills-demokasir" role="tabpanel" aria-labelledby="pills-demokasir-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/niew0MpjhKk" title="Aplikasi kargo ekspedisi"></iframe>
</div>
  </div>

  </div>
  

</div>

</div>
</div>

</Home>
)

export default KargoPage